<ng-container *ngIf="loaded">
    <h2>
        Assisted Self-Service Invitations
        <button class="icon--add btn--default" type="button" (click)="createInvitation()">Add Invitation</button>
    </h2>
    <p-table [value]="invitations" styleClass="p-datatable-striped">
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="10">
                    No records found
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Service</th>
                <th>Invitation Code</th>
                <th>PIN</th>
                <th class="w--date">Effective Date</th>
                <th class="w--date">End Date</th>
                <th>Sent To</th>
                <th>Message</th>
                <th>Created By</th>
                <th class="w--date-time">Created Date</th>
                <th class="w--actions">Actions</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr [pSelectableRow]="data">
                <td class="td--hover-show">{{data.assistedSelfServiceTypeDisplayValue}}</td>
                <td>{{data.token}}</td>
                <td>{{data.requiresPin ? data.pin : 'N/A'}}</td>
                <td>{{data.effectiveDate | shortDate}}</td>
                <td>{{data.endDate | shortDate}}</td>
                <td class="td--hover-show">
                    <ng-container *ngIf="data.email">{{data.email}}</ng-container>
                    <ng-container *ngIf="!data.email">{{data.phoneNumber | phoneNumberUSA}}</ng-container>
                </td>
                <td class="td--hover-show">{{data.message}}</td>
                <td class="td--hover-show">{{data.createdBy}}</td>
                <td>{{data.createdDate | dateTime}}</td>
                <td>
                    <a class="icon--delete" *ngIf="!data.expired" title="Expire Invitation" (click)="expireInvitation(data)"></a>
                    <ng-container *ngIf="data.expired">Expired</ng-container>
                    <a class="icon--print" *ngIf="!data.expired && (data.assistedSelfServiceTypeId === types.KnowledgeTest.id || data.assistedSelfServiceTypeId === types.OHVEducationCourse.id)" title="Print Invitation" (click)="printInvitation(data)"></a>
                </td>
            </tr>
        </ng-template>
    </p-table>
</ng-container>